import { gql, MutationHookOptions, useMutation } from '@apollo/client'
import { Mutation, MutationGenerateDocumentUploadUrlArgs, MutationGenerateImageUploadUrlArgs } from '../gen/models'

const GEN_S3_UPLOAD_IMAGE_URL_MUTATION = gql`
  mutation generateImageUploadUrl($input: UploadInput!) {
    generateImageUploadUrl(input: $input) {
      s3Key
      uploadUrl
      hiddenInputs
    }
  }
`

export const useGenS3UploadImageUrlMutation = (
  baseOptions?: MutationHookOptions<Pick<Mutation, 'generateImageUploadUrl'>, MutationGenerateImageUploadUrlArgs>,
) => useMutation(GEN_S3_UPLOAD_IMAGE_URL_MUTATION, baseOptions)

const GEN_S3_DOCUMENT_UPLOAD_URL_MUTATION = gql`
  mutation generateDocumentUploadUrl($input: UploadInput!) {
    generateDocumentUploadUrl(input: $input) {
      s3Key
      uploadUrl
      hiddenInputs
    }
  }
`

export const useGenS3DocumentUploadUrlMutation = (
  baseOptions?: MutationHookOptions<Pick<Mutation, 'generateDocumentUploadUrl'>, MutationGenerateDocumentUploadUrlArgs>,
) => useMutation(GEN_S3_DOCUMENT_UPLOAD_URL_MUTATION, baseOptions)

export type GenRebateEvidenceUploadUrlInput = {
  contractId: string
  rebateId: string
  fileName: string
  fileSize: number
}

export type GenRebateEvidenceUploadUrlResult = {
  generateRebateEvidenceUploadUrl: {
    s3Key: string
    uploadUrl: string
    hiddenInputs: Record<string, string> | null
    fileUrl: string
  }
}

const GEN_REBATE_EVIDENCE_UPLOAD_URL_MUTATION = gql`
  mutation generateRebateEvidenceUploadUrl($input: GenerateRebateEvidenceUploadUrlInput!) {
    generateRebateEvidenceUploadUrl(input: $input) {
      s3Key
      uploadUrl
      hiddenInputs
      fileUrl
    }
  }
`

export const useGenRebateEvidenceUploadUrlMutation = (
  baseOptions?: MutationHookOptions<GenRebateEvidenceUploadUrlResult, { input: GenRebateEvidenceUploadUrlInput }>,
) =>
  useMutation<GenRebateEvidenceUploadUrlResult, { input: GenRebateEvidenceUploadUrlInput }>(
    GEN_REBATE_EVIDENCE_UPLOAD_URL_MUTATION,
    baseOptions,
  )
